// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SignInPage__root--NNIe {
    width: 100%;
    min-height: calc(100vh - 241px);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
}

.SignInPage__wrapper--akMW {
    max-width: var(--content-max-width);
    width: 100%;
    margin: 0 auto;
}

@media screen and (max-width: 1023px) {

.SignInPage__wrapper--akMW {
        padding: 32px 24px
}
    }

@media screen and (min-width: 1024px) {

.SignInPage__wrapper--akMW {
        display: flex;
        flex-direction: row-reverse
}
    }

.SignInPage__form--D7Zh {
    border: 4px solid var(--obscure-color);
    background-color: var(--tertiary-color);
    border-radius: 12px;
    width: 100%;
    max-width: 386px;
    overflow: hidden;
}

@media screen and (max-width: 1023px) {

.SignInPage__form--D7Zh {
        margin: 0 auto
}
    }

.SignInPage__title--xyhV {
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    padding: 24px;
    color: var(--darkest-color);
    background-color: var(--main-light-color);
    border-bottom: 1px solid var(--obscure-color);
}

.SignInPage__formWrapper--R4ii {
    padding: 40px 24px;
    border-bottom: 1px solid var(--obscure-color);
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.SignInPage__error--SHn4 {
    color: var(--error-color);
    font-size: 14px;
    line-height: 21px;
    font-weight: 400;
}

.SignInPage__successfulIcon--afSv {
    padding: 8px;
    background-color: #349720;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    margin: 0 auto;
}

.SignInPage__successfulText--zBg0 {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: var(--secondary-color);
    text-align: center;
}

.SignInPage__successfulText--zBg0 > strong {
        font-weight: 700;
    }

.SignInPage__button--m4dt {
    width: 100%;
}

.SignInPage__issueReportText--f23Z {
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    color: var(--secondary-color);
    padding: 24px;
    background-color: var(--main-light-color);
}

.SignInPage__issueReportText--f23Z > a {
        text-decoration: underline;
        color: var(--secondary-color);
    }
`, "",{"version":3,"sources":["webpack://./src/ui/pages/SignInPage/SignInPage.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,+BAA+B;IAC/B,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;IAC5B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,WAAW;IACX,cAAc;AAUlB;;AARI;;AALJ;QAMQ;AAOR;IANI;;AAEA;;AATJ;QAUQ,aAAa;QACb;AAER;IADI;;AAGJ;IACI,sCAAsC;IACtC,uCAAuC;IACvC,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AAKpB;;AAHI;;AARJ;QASQ;AAER;IADI;;AAGJ;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,2BAA2B;IAC3B,yCAAyC;IACzC,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,6CAA6C;IAC7C,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;AAKtB;;AAHI;QACI,gBAAgB;IACpB;;AAGJ;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,yCAAyC;AAM7C;;AAJI;QACI,0BAA0B;QAC1B,6BAA6B;IACjC","sourcesContent":[".root {\n    width: 100%;\n    min-height: calc(100vh - 241px);\n    background-position: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.wrapper {\n    max-width: var(--content-max-width);\n    width: 100%;\n    margin: 0 auto;\n\n    @media (--mobile) {\n        padding: 32px 24px;\n    }\n\n    @media (--large) {\n        display: flex;\n        flex-direction: row-reverse;\n    }\n}\n\n.form {\n    border: 4px solid var(--obscure-color);\n    background-color: var(--tertiary-color);\n    border-radius: 12px;\n    width: 100%;\n    max-width: 386px;\n    overflow: hidden;\n\n    @media (--mobile) {\n        margin: 0 auto;\n    }\n}\n\n.title {\n    font-size: 24px;\n    line-height: 32px;\n    font-weight: 700;\n    padding: 24px;\n    color: var(--darkest-color);\n    background-color: var(--main-light-color);\n    border-bottom: 1px solid var(--obscure-color);\n}\n\n.formWrapper {\n    padding: 40px 24px;\n    border-bottom: 1px solid var(--obscure-color);\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.error {\n    color: var(--error-color);\n    font-size: 14px;\n    line-height: 21px;\n    font-weight: 400;\n}\n\n.successfulIcon {\n    padding: 8px;\n    background-color: #349720;\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    margin: 0 auto;\n}\n\n.successfulText {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    color: var(--secondary-color);\n    text-align: center;\n\n    > strong {\n        font-weight: 700;\n    }\n}\n\n.button {\n    width: 100%;\n}\n\n.issueReportText {\n    font-size: 15px;\n    font-weight: 400;\n    line-height: 20px;\n    text-align: center;\n    color: var(--secondary-color);\n    padding: 24px;\n    background-color: var(--main-light-color);\n\n    > a {\n        text-decoration: underline;\n        color: var(--secondary-color);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SignInPage__root--NNIe`,
	"wrapper": `SignInPage__wrapper--akMW`,
	"form": `SignInPage__form--D7Zh`,
	"title": `SignInPage__title--xyhV`,
	"formWrapper": `SignInPage__formWrapper--R4ii`,
	"error": `SignInPage__error--SHn4`,
	"successfulIcon": `SignInPage__successfulIcon--afSv`,
	"successfulText": `SignInPage__successfulText--zBg0`,
	"button": `SignInPage__button--m4dt`,
	"issueReportText": `SignInPage__issueReportText--f23Z`
};
export default ___CSS_LOADER_EXPORT___;
